import {
  SET_XERO_ACCOUNTS,
  SET_PAYMENT_TYPES_XERO,
  SET_TILL_MOVEMENT_TYPES_XERO,
  SET_TAX_GROUP_XERO,
  SET_XERO_TAX_RATES,
} from '../../constants/constant_xero';

const INTITAL_STATE = {
  xero: {
    accounts: [],
    tax_rates: [],
    payment_types: [],
    tax_codes: [],
    till_movement_types: [],
    tax_groups: [],
  },
};

export default function integrationReducer(state = INTITAL_STATE, action) {
  switch (action.type) {
    case SET_XERO_ACCOUNTS:
      return {
        ...state,
        xero: {
          ...state.xero,
          accounts: action.payload,
        },
      };

    case SET_XERO_TAX_RATES:
      return {
        ...state,
        xero: {
          ...state.xero,
          tax_rates: action.payload,
        },
      };

    case SET_PAYMENT_TYPES_XERO:
      return {
        ...state,
        xero: {
          ...state.xero,
          payment_types: action.payload,
        },
      };

    case SET_TILL_MOVEMENT_TYPES_XERO:
      return {
        ...state,
        xero: {
          ...state.xero,
          till_movement_types: action.payload,
        },
      };

    case SET_TAX_GROUP_XERO:
      return {
        ...state,
        xero: {
          ...state.xero,
          tax_groups: action.payload,
        },
      };

    default: {
      return state;
    }
  }
}
